export default __webpack_public_path__ + "static/media/swimming.6ac2ccff.png";